import ImageSection from "@/components/landing/ImageSection";

const capabilities = [
  {
    title: "Öka kundnöjdheten",
    desc: "Gäster märker inte systemet bakom kulisserna — de märker att maten kommer rätt, i tid, och att personalen är närvarande. KitchenFlow ser till att varje bord får den upplevelse du lovar.",
  },
  {
    title: "Minska stress för personalen",
    desc: "Färre missförstånd betyder färre omlagningar, färre extrapass och mindre tid som går åt att rätta till misstag. KitchenFlow hjälper dig att göra mer med den personal du redan har.",
  },
  {
    title: "Sparar tid på inköp",
    desc: "Istället för att räkna ut ingredienser manuellt kopplar systemet rätter till leverantörer och enheter – inköpslistor genereras automatiskt utifrån vad som ska tillagas.",
  },
];

const BuiltForSection = () => {
  return (
    <ImageSection overlay id="features">
      <div className="glass-card p-8 md:p-10 max-w-[620px]">
        <h2 className="text-[clamp(1.75rem,3.5vw,2.375rem)] font-bold tracking-tight leading-[1.18] text-balance text-foreground">
          Därför väljer restauranger oss
        </h2>

        <div className="mt-10 space-y-8">
          {capabilities.map((cap) => (
            <div key={cap.title} className="space-y-1.5">
              <h3 className="text-[15px] font-semibold text-foreground">
                {cap.title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ color: "rgba(15,23,42,0.7)" }}
              >
                {cap.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </ImageSection>
  );
};

export default BuiltForSection;
